import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import UserMenu from '../UserMenu';
import HeaderLogo from '../HeaderLogo';
import UserNotifications from '../../components/UserNotifications/UserNotifications';
import { NavigationStore } from './NavigationStore';
import { observer } from 'mobx-react';

export type activeTab =
    | 'contact'
    | 'dashboard'
    | 'dives'
    | 'shared-dives'
    | 'settings';

// tslint:disable-next-line:no-any
export interface INavigationProps extends RouteComponentProps<any> {
    baseUrl: string;
}

interface INavigationState {
    dropDownMenu: string;
    mobileSearch: string;
    mobileNav: string;
    active: string;
}

@observer
class Navigation extends React.Component<INavigationProps, INavigationState> {
    private timerDropDownMenuClose: NodeJS.Timer | null = null;
    private store = NavigationStore.getInstance();

    constructor(props: INavigationProps) {
        super(props);
        this.state = {
            mobileSearch: 'hidden',
            mobileNav: 'hidden',
            active: 'dashboard',
            dropDownMenu: ''
        };
    }

    public render() {
        return (
            <div>
                <header className="header header--logged">
                    <HeaderLogo />

                    <nav className={`nav`}>
                        <ul>
                            <li>
                                <Link
                                    to={`${this.props.baseUrl}`}
                                    className={
                                        this.store.active === 'dashboard'
                                            ? 'nav--active'
                                            : ''
                                    }
                                    onClick={() => this.setActive('dashboard')}
                                >
                                    Dashboard
                                </Link>
                            </li>
                            <li
                                className="with-dropdown"
                                onMouseLeave={() =>
                                    this.onDropDownMenuMouseLeave()
                                }
                                onMouseEnter={() =>
                                    this.onDropDownMenuMouseEnter()
                                }
                            >
                                <span
                                    className={
                                        this.store.active === 'dives'
                                            ? 'nav--active'
                                            : ''
                                    }
                                    onClick={() =>
                                        this.toggleDropDownMenuOpened()
                                    }
                                >
                                    Dives
                                </span>

                                <ul
                                    className={
                                        'dropdown ' + this.state.dropDownMenu
                                    }
                                >
                                    <li>
                                        <Link
                                            to="/app/dives"
                                            onClick={() => {
                                                this.toggleDropDownMenuOpened();
                                                this.setActive('dives');
                                            }}
                                        >
                                            My Dives
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/app/shared-dives"
                                            onClick={() => {
                                                this.toggleDropDownMenuOpened();
                                                this.setActive('dives');
                                            }}
                                        >
                                            Shared Dives
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link
                                    to={`${this.props.baseUrl}/settings`}
                                    className={
                                        this.store.active === 'settings'
                                            ? 'nav--active'
                                            : ''
                                    }
                                    onClick={() => this.setActive('settings')}
                                >
                                    Settings
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${this.props.baseUrl}/contact`}
                                    className={
                                        this.store.active === 'contact'
                                            ? 'nav--active'
                                            : ''
                                    }
                                    onClick={() => this.setActive('contact')}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    <button
                        type="button"
                        className="navbar-toggle"
                        onClick={() => this.toggleMobileNav}
                    >
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                    </button>

                    <div className="profileHolder">
                        <UserNotifications />
                        <UserMenu baseUrl={this.props.baseUrl} />
                        <Link
                            to={`${this.props.baseUrl}/new-dive`}
                            className="btn btn--smallpill btn--backroundRed btn--borderRed desktop"
                        >
                            new log
                        </Link>
                        <Link
                            to={`${this.props.baseUrl}/new-dive`}
                            className="btn btn--smallpill btn--backroundRed btn--borderRed tablet"
                        />
                    </div>
                </header>

                <div className={'mobileSearch ' + this.state.mobileSearch}>
                    <input type="text" placeholder="Search" />
                </div>

                <nav className={'mobileNav ' + this.state.mobileNav}>
                    <ul>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/new-dive`}
                                className="red"
                                onClick={() => this.toggleMobileNav()}
                            >
                                New Log
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}`}
                                className={
                                    this.store.active === 'dashboard'
                                        ? 'nav--active'
                                        : ''
                                }
                                onClick={() => this.setActive('dashboard')}
                            >
                                Dashboard
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/dives`}
                                className={
                                    this.store.active === 'dives'
                                        ? 'nav--active'
                                        : ''
                                }
                                onClick={() => this.setActive('dives')}
                            >
                                My Dives
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/shared-dives`}
                                className={
                                    this.store.active === 'shared-dives'
                                        ? 'nav--active'
                                        : ''
                                }
                                onClick={() => this.setActive('shared-dives')}
                            >
                                Shared Dives
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/settings`}
                                className={
                                    this.store.active === 'settings'
                                        ? 'nav--active'
                                        : ''
                                }
                                onClick={() => this.setActive('settings')}
                            >
                                Settings
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${this.props.baseUrl}/contact`}
                                className={
                                    this.store.active === 'contact'
                                        ? 'nav--active'
                                        : ''
                                }
                                onClick={() => this.setActive('contact')}
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </nav>

                <div // tslint:disable-next-line:max-line-length
                    className={
                        'mobileNavOverlay' +
                        (this.state.mobileNav === 'opened' ||
                        this.state.mobileSearch === 'opened'
                            ? ' overlayDisplay'
                            : '')
                    }
                />
            </div>
        );
    }

    private setActive(item: activeTab) {
        this.store.setActive(item);
        this.setState({ active: item, mobileNav: 'hidden', dropDownMenu: '' });
    }

    private toggleDropDownMenuOpened() {
        let newDropDownMenu =
            this.state.dropDownMenu === 'opened' ? '' : 'opened';
        this.setState({ dropDownMenu: newDropDownMenu });
    }

    /*private toggleMobileSearch() {
        let className =
            this.state.mobileSearch === 'hidden' ? 'opened' : 'hidden';
        this.setState({ mobileSearch: className, mobileNav: 'hidden' });
    }*/

    private toggleMobileNav() {
        let className = this.state.mobileNav === 'hidden' ? 'opened' : 'hidden';
        this.setState({ mobileSearch: 'hidden', mobileNav: className });
    }

    private onDropDownMenuMouseLeave() {
        this.timerDropDownMenuClose = setTimeout(() => {
            this.setState({ dropDownMenu: '' });
            this.timerDropDownMenuClose = null;
            // tslint:disable-next-line:align
        }, 700);
    }

    private onDropDownMenuMouseEnter() {
        if (this.timerDropDownMenuClose !== null) {
            clearTimeout(this.timerDropDownMenuClose);
            this.timerDropDownMenuClose = null;
        }
    }
}

export default withRouter<INavigationProps>(Navigation);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Navigation/Navigation.tsx